<template>
  <div>
    <a-switch-field
      varName="password_options.password_history.enabled"
      varLabel="Password History"
      :varRequired="true"
      :varInitial="data.password_options.password_history.enabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="true"
      description="Password history only available on higher subscription plans."
    />
    <a-number-field
      varName="password_options.password_history.size"
      varLabel="History Size"
      :varRequired="true"
      :varInitial="data.password_options.password_history.size"
      :formLayout="formLayout"
      :size="size"
      :min=0
      :max=10
    />
    <a-switch-field
      varName="password_options.password_no_personal_info.enabled"
      varLabel="No Personal Info"
      :varRequired="true"
      :varInitial="data.password_options.password_no_personal_info.enabled"
      :formLayout="formLayout"
      :size="size"
      description="Checks the similarity between the password and a set of attributes of the user. Raise password validation error if true."
    />
    <a-switch-field
      varName="password_options.password_dictionary.enabled"
      varLabel="No Common Password"
      :varRequired="true"
      :varInitial="data.password_options.password_dictionary.enabled"
      :formLayout="formLayout"
      :size="size"
      description="Check if password occurs in a list of common passwords. Raise password validation error if true."
    />
    <a-switch-field
      varName="password_options.pwned_password.enabled"
      varLabel="Compromised Password Check"
      :varRequired="true"
      :varInitial="data.password_options.pwned_password.enabled"
      :formLayout="formLayout"
      :size="size"
      description="Perform validation against compromised password database. Raise password validation error if true."
    />
    
  </div>
</template>

<script>

export default {
  data() {
    return {

    };
  },
  components: {

  },
  props: {
    formLayout: String,
    size: String,
    data: Object
  }
};
</script>